import "./Banner.scss"
import React from "react"
import { Box } from "@mui/material"
import Text from "../Text"

const DaiMigrationBanner = () => {
  return (
    <Box className="banner-container">
      <Box zIndex={1}>
        <h3>DAI Delisting Notice</h3>
        <Box mt="12px" mb="24px">
          <Text>
            DAI is being retired and migrating to USDS. Please withdraw your
            liquidity and send DAI to your Crypto.com App wallet for automatic
            1:1 conversion to USDS.
          </Text>
        </Box>
        <Box display="flex" gap="24px">
          <a
            href="https://crypto.com/exchange"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none" }}
          ></a>
        </Box>
      </Box>
    </Box>
  )
}

export default DaiMigrationBanner
